import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const SelectItemsDialog = ({
  create,
  items,
  obj: { range, ...obj },
  onClose,
  openState: [open, setOpen],
  readonly,
}) => {
  const [itemIDs, setItemIDs] = useState([]);

  useEffect(() => {
    setItemIDs(obj?.items || []);
  }, [obj?.items]);

  const getObjectType = (__typename) => {
    switch (__typename) {
      case "DynamicBreakParagraphTag":
        return "Break Paragraph Tag";
      case "ItemPointReference":
        return "Item Point Reference";
      default:
        return __typename;
    }
  };
  const handleCancel = () => {
    setItemIDs([]);
    setOpen(false);
  };
  const handleClose = () => {
    onClose(create)({ ...obj, items: [...itemIDs] });
    setItemIDs([]);
    setOpen(false);
  };
  const handleItemToggle = (id) => (_e) => {
    if (readonly) return;
    if (itemIDs.includes(id)) {
      setItemIDs(itemIDs.filter((val) => val !== id));
    } else {
      setItemIDs([...itemIDs, id]);
    }
  };

  return (
    <Dialog maxWidth="xs" onClose={handleClose} open={open}>
      <DialogTitle>
        {(readonly && "View") || (create ? "Create" : "Update")}{" "}
        {getObjectType(obj.__typename)}
      </DialogTitle>
      <DialogContent>
        <List>
          {items.map(({ id, name }) => (
            <ListItem dense key={id} onClick={handleItemToggle(id)}>
              <ListItemIcon>
                <Checkbox
                  checked={itemIDs.includes(id)}
                  disabled={readonly}
                  edge="start"
                  value={id}
                />
              </ListItemIcon>
              <ListItemText id={id} primary={name} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        {readonly && (
          <Button onClick={handleCancel} variant="text">
            Close
          </Button>
        )}
        {!readonly && (
          <>
            <Button onClick={handleCancel} variant="text">
              Cancel
            </Button>
            <Button
              color="primary"
              disabled={!itemIDs.length}
              onClick={handleClose}
              variant="contained"
            >
              {create ? "Create" : "Update"}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export { SelectItemsDialog };
